import type { FaireProductEntity } from "../../entity_types/product";

export const p_pwb943judh: FaireProductEntity = {
  token: "p_pwb943judh",
  type: "product",
  name: "Stress Relief Roller Ball Lavender/Rosemary Essential Oil",
  brandToken: "b_7jqwqwjp5c",
  brandName: "Aromalee Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/bd70f627d29871a5a0a4f681b781d6b7cf0292e95965781d5ec0d10a8bf76fd9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d93fae3d0ed535258a5dd5dfcba9a458cea95b97ac878c01ca030ec202c603b0.jpeg",
    "https://cdn.faire.com/fastly/02d55a8384051fbedb592539185e17a867cc66ea5d1244a6b149e6bda9fabd78.png",
  ],
  priceDollars: 12.47,
  description:
    "100% Natural Botanical Oil Blend:\n▫️Infused With Amethyst Crystals & Organic Lavender \n▫️Scented with Lavender & Rosemary Essential Oils \n▫️ Hand Poured With Organic Grapeseed Oil \n\nBenefits: \n▫️Boosts Relaxation and Insight \n▫️Reduces Anxiety and Stress \n▫️Aids With Insomnia and Nausea \n\nHow to apply:\n▫️Roll on with intention along hairline, head, neck, shoulders, and wrists \n\nDisclaimer: \n▫️Not FDA approved \n▫️For topical use only",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:30.391Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
